import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { StoreType } from 'polotno/model/store';
import AddFrameButton from './AddFrameButton';
import Frame from './Frame';

const FramesContainer = styled.div`
    display: flex;
    align-items: center;
    padding-inline-start: 10px;
    height: 150px;
    background: #f1f2f6;
    color: black;
    gap: 15px;
`;

const placeHolderImage =
    'https://static.remove.bg/remove-bg-web/c05ac62d076574fad1fbc81404cd6083e9a4152b/assets/start-1abfb4fe2980eabfbbaaa4365a0692539f7cd2725f324f904565a9a744f8e214.jpg';
export default observer(({ store }: { store: StoreType }) => {
    return (
        <FramesContainer>
            {store.pages.map((page, i) => (
                <Frame
                    key={page.id}
                    index={i}
                    src={placeHolderImage}
                    onClick={() => store.selectPage(page.id)}
                    selected={store.activePage?.id === page.id}
                />
            ))}
            <AddFrameButton onClick={() => store.addPage({ width: 1920, height: 1080 })} />
        </FramesContainer>
    );
});
